import { Suspense, useState } from 'react';
import ErrorBoundary from '@/app/components/feedback/ErrorBoundary';
import { lazyWithRetry } from '@/app/helpers/lazyWithRetry';
import { useAiModuleEnabled } from '../core/_hooks';
import { isChatwootConfigured } from '../core/provider';
import './AgentChatMessenger.scss';

const UnifiedChatContainer = lazyWithRetry('UnifiedChatContainer', () => import('./UnifiedChatContainer'));

const AgentChatWidget = () => {
  const aiEnabled = useAiModuleEnabled();
  const chatwoot = isChatwootConfigured();
  const [isOpen, setIsOpen] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);

  if (!chatwoot && !aiEnabled) return null;

  const openPanel = () => {
    setHasOpened(true);
    setIsOpen(true);
  };

  const togglePanel = () => {
    if (isOpen) setIsOpen(false);
    else openPanel();
  };

  return (
    <>
      {hasOpened ? (
        <div
          className={`agent-chat-widget__panel position-fixed ${isOpen ? 'agent-chat-widget__panel--open' : ''}`}
          data-testid="agent-chat-panel"
        >
          <ErrorBoundary>
            <Suspense fallback={null}>
              <UnifiedChatContainer onClose={() => setIsOpen(false)} />
            </Suspense>
          </ErrorBoundary>
        </div>
      ) : null}
      <button
        type="button"
        className={`agent-chat-widget__launcher btn btn-primary btn-icon rounded-circle shadow position-fixed ${isOpen ? '' : 'pulse pulse-primary'}`}
        aria-label={isOpen ? 'Fechar assistente' : 'Abrir assistente'}
        onClick={togglePanel}
        data-testid="agent-chat-fab"
      >
        {isOpen ? (
          <i aria-hidden="true" className="bi bi-x-lg fs-2" />
        ) : (
          <img
            alt=""
            className="agent-chat-widget__launcher-avatar"
            height={64}
            src="/media/avatars/bot-azul.jpeg"
            width={64}
          />
        )}
        {isOpen ? null : <span aria-hidden="true" className="agent-chat-widget__pulse-ring pulse-ring" />}
      </button>
    </>
  );
};

export default AgentChatWidget;
